module.exports = __webpack_public_path__ + "img/Movies-Everywhere_Logo.26f05e4f.png";